import React from 'react';

import { ResultList } from '../../../helpers/uiComponents/ResultList';
import { SearchForm } from '../../../helpers/uiComponents/Search';
import { Reload } from '../../../helpers/uiComponents/Reload';

import NewClientForm from './AddClientForm';
import ClientFilters from './ClientFilters';
// import BulkImport from './BulkImport';
import { showPopup } from '../../../helpers/uiFunctions/uiActions';
import ClientMap from './ClientMap';


class LeftColumn extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
			clientList: [],
			allClients: [],
			filter: "all"
		}
        this.setFilter = this.setFilter.bind(this);
	}

	componentDidUpdate(prevProps) {
		try {
			if( this.props.clients && (this.props.clients !== prevProps.clients )) {
				this.setState({
					allClients: this.props.clients,
					clientList: this.props.clients,
				});
			}
		} catch (error) {
			console.log(error);
		}
	}

    setFilter(status, i) {
		var newClients = this.state.allClients;
		var menuItems = document.querySelectorAll('#client .list-tabs .tab');
		
		for (var x = menuItems.length - 1; x >= 0; x--) {
			menuItems[x].classList.remove('active');
			menuItems[i-1].classList.add('active');
		}

		if (status === "all") {
			// silence is golden
		} else if (status === "velocity") {
			newClients = newClients.filter(client => { return client.velocity === true});
		} else if (status === "lite") {
			newClients = newClients.filter(client => { return client.servicePackage === "lite"});
		} else if (status === "other") {
			newClients = newClients.filter(client => { return client.velocity === false});
		} else if (status === "active" || status === "onboarding" || status === "archived") {
			newClients = newClients.filter(client => { return client.status === status});
		} else if (status === "bigBobs" || status === "floorsToCeiling") {
			newClients = newClients.filter(client => { return client.franchiseName === status});
		} else if(status === "ela") {
			newClients = newClients.filter(client => { return client.ela === true });
		} else if(status === "omnify") {
			newClients = newClients.filter(client => { return client.omnify === true });
		}
		this.setState({
			clientList: newClients,
			filter: status,
		});
	}

    render() {
        const { clientList, filter } = this.state;
        const getClient = this.props.getClient;
		const loadClients = this.props.loadClients;
		const resetProfile = this.props.resetProfile;
        
        return(
            <div className="column left-column" id="list-column">
                <Reload click={loadClients} />
				<section className="section">
                    <h3>Clients</h3>
                    <button className="button new" onClick={() => showPopup("clientMap")}>Client Map</button>
					<button className="button new" onClick={() => showPopup("addClientForm")}>Add New Client +</button>
					{/* <button className="button new" onClick={() => showPopup("bulkImportForm")}>Bulk Import Clients +</button> */}
                </section>
				<ClientMap />
				<NewClientForm
                    reloadClients={loadClients}
					load={getClient}
					clientList={clientList}
                />
				{/* <BulkImport /> */}
                <ClientFilters
                    count={clientList.length}
                    setFilter={this.setFilter}
                    filter={filter}
                />
                <SearchForm page="client" />
                <ResultList
                    page={"client"}
                    data={clientList}
                    load={getClient}
					resetProfile={resetProfile}
                />
            </div>
        )
    }
}
export default LeftColumn;



// WEBPACK FOOTER //
// ./src/component_client/components/ClientExplorer/Explorer.js